import React, {useState} from 'react'
import {Link} from 'react-router-dom'

import headerLogoPng from '../../resources/img/header-logo.png'

import MainMenu from './main-menu'
import DroppedMenu from './dropped-menu'
import BasketPanel from './basket-panel'
import ProfilePanel from './profile-panel'
import BasketIndicator from "./basket-indicator";
import Search from './search'

const Header = () => {
  const [categoryId, setCategoryId] = useState(null);
  const [droppedMenuVisible, setDroppedMenuVisible] = useState(false);
  const [hiddenPanelClassName, setHiddenPanelClassName] = useState('');
  const [isSearchVisible, setSearchVisible] = useState(false);

  const handlePicClick = (event, inputValue) => {
    event.preventDefault();

    if (!inputValue) {
      const {target} = event;

      if (target.classList.contains('header-main__pic_profile') ||
        target.classList.contains('header-main__pic_basket')) {
        const newValue = target.classList[1];

        setHiddenPanelClassName(newValue !== hiddenPanelClassName ? newValue : '')
      }

      if (target.classList.contains('header-main__pic_search')) {
        setSearchVisible(!isSearchVisible)
      }
    }
  };

  return (
    <header className="header">
      <div className="top-menu">
        <div className="wrapper">
          <ul className="top-menu__items">
            <li className="top-menu__item">
              <Link to="/">Возврат</Link>
            </li>
            <li className="top-menu__item">
              <Link to="/">Доставка и оплата</Link>
            </li>
            <li className="top-menu__item">
              <Link to="/">О магазине</Link>
            </li>
            <li className="top-menu__item">
              <Link to="/">Контакты</Link>
            </li>
            <li className="top-menu__item">
              <Link to="/">Новости</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="header-main">
        <div className="header-main__wrapper wrapper">
          <div className="header-main__phone">
            <a href="tel:+7-495-790-35-03">+7 495 79 03 5 03</a>
            <p>Ежедневно: с 09-00 до 21-00</p>
          </div>
          <div className="header-main__logo">
            <Link to="/">
              <h1>
                <img src={headerLogoPng} alt="logotype"/>
              </h1>
            </Link>
            <p>Обувь и аксессуары для всей семьи</p>
          </div>
          <div className="header-main__profile">
            <div className="header-main__pics"
                 onClick={handlePicClick}>
              <div className={`header-main__pic header-main__pic_search ${isSearchVisible ?
                'header-main__pic_search_is-hidden' : ''}`}>
              </div>
              <div className="header-main__pic_border"/>
              <div className="header-main__pic header-main__pic_profile">
                <div className={`header-main__pic_profile_menu${hiddenPanelClassName === 'header-main__pic_profile' ?
                  '_is-active' : ''}`}/>
              </div>
              <div className="header-main__pic_border"/>
              <div className="header-main__pic header-main__pic_basket">
                <BasketIndicator/>
                <div className={`header-main__pic_basket_menu${hiddenPanelClassName === 'header-main__pic_basket' ?
                  '_is-active' : ''}`}/>
              </div>
            </div>
            <Search isVisible={isSearchVisible}
                    onPicClick={handlePicClick}/>
          </div>
        </div>
        <div className={`header-main__hidden-panel hidden-panel ${hiddenPanelClassName ?
          'header-main__hidden-panel_visible' : ''}`}>
          <div className="wrapper">
            {hiddenPanelClassName === 'header-main__pic_profile' &&
            <ProfilePanel setHiddenPanelClassName={setHiddenPanelClassName}/>}
            {hiddenPanelClassName === 'header-main__pic_basket' &&
            <BasketPanel setHiddenPanelClassName={setHiddenPanelClassName}/>}
          </div>
        </div>
      </div>
      <MainMenu droppedMenuVisible={droppedMenuVisible}
                setDroppedMenuVisible={setDroppedMenuVisible}
                categoryId={categoryId}
                setCategoryId={setCategoryId}/>
      <DroppedMenu visible={droppedMenuVisible}
                   setVisible={setDroppedMenuVisible}
                   categoryId={categoryId}/>
    </header>
  )
};

export default Header
